
(function() {
  'use strict';

var loadMatchingRecords = function ($timeout, $sce, ajaxCall, timestampUrl) {
   return {
        restrict: "A",
        scope: true,
        bindToController: {
            formModel: "&formData",
            loading:   "=" // we want to expose loading, so we can disable button while the results are being loaded
        },
        controllerAs: "ctrl",
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
            var _this = this;

            _this.loading = false;

            $scope.loadContent = function() {
                _this.loading = true;
                ajaxCall.getData(timestampUrl.add($attrs.ajaxContentUrl), jQuery.param( _this.formModel() ) ).then(
                    function(response){
                        _this.loading = false;
                        $scope.potentialDuplicatesHtml = $sce.trustAsHtml(response.data);
                    }, function(response){
                        _this.loading = false;
                        $scope.isError = true;
                        $scope.errorMsg = $sce.trustAsHtml( errorMsgFactory.connectionError(response) );
                    });
            };

            $timeout(function(){
                $scope.$watch(function(){
                    return _this.formModel();
                }, function( newVal, oldVal) {
                    if(newVal != oldVal) {
                        $scope.loadContent();
                    }
                }, true);
            });
        }],
        template: [
            '<div>',
                '<div ng-if="isError" class="alert alert-danger" ng-bind-html="errorMsg"></div>',
                '<div ng-show="ctrl.loading" style="text-align:center;">',
                    '<div style="margin-top:15px; margin-bottom:15px;" class="loading-spinner">Loading, please wait...</div>',
                '</div>',
                '<p ng-if="!formModel.hasDuplicates && !ctrl.loading">None found.</p>',
                '<div ng-show="!ctrl.loading" bind-html-compile="potentialDuplicatesHtml"></div>',
            '</div>'].join(''),
        replace: true
    };
};

loadMatchingRecords.$inject = ['$timeout', '$sce', 'ajaxCall', 'timestampUrl'];
angular.module('app').directive('loadMatchingRecords', loadMatchingRecords);


/*var loadMatchingRecords = function ($http, transformToFormPost, $timeout) {
   return {
        restrict: "A",
        scope: true,
        bindToController: {
            formData: "&"
        },
        controllerAs: "ctrl",
        controller: function($scope, $element, $attrs) {
            var ajaxUrl = $attrs.ajaxContentUrl;
            var container = $attrs.container;
            var dataHolder = angular.element(document.getElementById(container));

            $scope.initialLoad = true;

            $scope.loadContent = function () {
                console.log('ajaxurl'+ajaxUrl)
                if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
                    var ajaxData = $('#primary').serialize();
                    $http({
                        method: "post",
                        url: ajaxUrl,
                        transformRequest: transformToFormPost,
                        data: ajaxData
                    }).then(
                    function(response){
                        dataHolder.html(response.data);
                    });
                }
            }
        },
        require: "loadMatchingRecords",
        link: function(scope, element, attrs, ctrl){
            $timeout(function(){
                scope.$watch(function(){
                    return ctrl.formData();
                }, function( newVal, oldVal) {
                    if(scope.initialLoad || newVal != oldVal) {
                       scope.initialLoad = false;
                       scope.loadContent();
                    }
                }, true);
            });
        }
    };
}

loadMatchingRecords.$inject = ['$http', 'transformToFormPost', '$timeout'];
angular.module('app').directive('loadMatchingRecords', loadMatchingRecords);
*/

}());